__webpack_require__.p = "/mastermind-react/";